var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "typing-dots" }, [
      _c("div", { staticClass: "wrapper" }, [
        _c("i", { staticClass: "fas fa-circle" })
      ]),
      _c("div", { staticClass: "wrapper" }, [
        _c("i", { staticClass: "fas fa-circle" })
      ]),
      _c("div", { staticClass: "wrapper" }, [
        _c("i", { staticClass: "fas fa-circle" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }